import React from "react";
import {Table} from "react-bootstrap";
import k1utils from "../../../../../util/k1utils";

export function WizardFormDelivery({ data }) {
    return (
        <>
            <Table striped bordered hover>
                <thead className="thead-dark">
                <tr>
                    <th>받는사람</th>
                    <th>전화번호</th>
                    <th>주소</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>{data?.to_name}</td>
                    <td>{data?.phone_number && k1utils.phoneNumberFormat(data.phone_number)}</td>
                    <td> {data.zipcode ? `(${data.zipcode})` : ''} <br/>
                        {`${data.address1 ? data.address1 : ''} ${data?.address2 ? data?.address2 : ''}`}
                    </td>
                </tr>
                </tbody>
            </Table>
            {/*<h6 className="font-weight-bolder mb-3">배송여부</h6>*/}
            {/*<div className="text-dark-50 line-height-lg">*/}
            {/*    <div>{data?.to_name}</div>*/}
            {/*    <div>{data?.phone_number}</div>*/}
            {/*    <div>{data?.address1}</div>*/}
            {/*    <div>{data?.address2}</div>*/}
            {/*    <div>{data?.zipcode}</div>*/}
            {/*</div>*/}
            {/*<div className="separator separator-dashed my-5"/>*/}
        </>
    )
}